<template>
    <NuxtLayout name="malt-base-layout">
        <LazyNavbar :show-search-unlogged="showSearchUnlogged" :is-funnel-mode="isFunnelMode" />
        <LoadingIndicator />
        <slot />
        <template #admin-tools>
            <slot name="admin-tools" />
        </template>
        <LazyFooter v-if="!isLoading" />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {LazyNavbar, LazyFooter, NuxtLayout, LoadingIndicator} from '#components';
    import {useLoadingIndicator} from '#imports';

    interface Props {
        showSearchUnlogged?: boolean;
        isFunnelMode?: boolean;
    }
    withDefaults(defineProps<Props>(), {showSearchUnlogged: true, isFunnelMode: false});

    const {isLoading} = useLoadingIndicator();
</script>
